export default __webpack_public_path__ + "static/media/reg-2.a6130166.jpg";